export default "__VITE_ASSET__DCDUbgrD__"